"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeBotTriggerPrice = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
// 订单设置止盈止损
function changeBotTriggerPrice(id, orderType, req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/${orderType}/${id}/trigger_price/`;
    return trade_utils_lib_1.Network.post({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.changeBotTriggerPrice = changeBotTriggerPrice;
